import { ConfirmModalOptions } from 'redux/mode/reducers';
import Modal from '..';
import { showConfirmModal } from 'redux/mode/actions';
import { useDispatch } from 'react-redux';

interface ConfirmModalProps {
	options: ConfirmModalOptions;
}

const ConfirmModal = ({ options }: ConfirmModalProps) => {
	const {
		title,
		cancelLabel,
		submitLabel,
		altActionLabel,
		description,
		onCancel,
		onSubmit,
		onAltAction,
	} = options;
	const dispatch = useDispatch();

	const onKeyPress = (e: React.KeyboardEvent<HTMLElement>) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			submit();
		}
	};

	const closeModal = () => {
		dispatch(showConfirmModal(null));
	};

	const cancel = onCancel
		? () => {
				closeModal();
				onCancel();
		  }
		: closeModal;

	const submit = () => {
		closeModal();
		onSubmit();
	};

	const altAction =
		onAltAction &&
		(() => {
			closeModal();
			onAltAction();
		});

	const onClickOutside = (e: { preventDefault: () => void }) => {
		e.preventDefault();
		closeModal();
	};

	return (
		<div onKeyDownCapture={onKeyPress}>
			<Modal
				disabled={false}
				cancelLabel={cancelLabel ?? null}
				submitLabel={submitLabel}
				altActionLabel={altActionLabel}
				title={title}
				description={description}
				onCancel={cancel}
				onSubmit={submit}
				onAltAction={altAction}
				onClickOutside={onClickOutside}
			/>
		</div>
	);
};

export default ConfirmModal;
